// extracted by mini-css-extract-plugin
module.exports = {"button":"sessionTimeoutDialog_button__3bw4f","progress-bar-custom":"sessionTimeoutDialog_progress-bar-custom__3_cqw"};